<div *ngIf="!spinner">
    <div class="card-header bg-primary hide-on-pdf">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <h4 class="heading text-2xl font-bold ff-robo text-white my-2 my-md-0 ms-md-4">
                View Questionnarie
            </h4>
            <div class="d-flex gap-2 me-md-4">
                <button *ngIf="!error" (click)="downloadPdf()" class="btn btn-light btn-sm no-print">
                    <i class="fa fa-download"></i>&nbsp;<b>Download PDF</b>
                </button>
                <button (click)="back()" class="btn btn-xl text-dark float-right no-print">
                    <i class="fa fa-reply"></i>&nbsp;<b>Back</b>
                </button>
            </div>
        </div>
    </div>
    <div class="form-details-container" #pdfContent id="pdf-content">
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
            <img src={{eltai}} alt="Logo 1" class="logo-img">
            <h4 class="text-center fw-bold flex-grow-1 m-0 text-nowrap">{{questionnarieData?.title}}</h4>
            <img src={{india_reads}} alt="Logo 2" class="logo-img">
        </div>
        <div class="personal-info-section">
            <div class="form-row">
                <div class="form-group">
                    <div class="form-label">Name</div>
                    <div class="form-separator">:</div>
                    <div class="form-value">{{questionnarieData?.name}}</div>
                </div>
            </div>
            <div *ngIf="!showData" class="form-row">
                <div class="form-group">
                    <div class="form-label">Email ID</div>
                    <div class="form-separator">:</div>
                    <div class="form-value">{{questionnarieData?.email}}</div>
                </div>
            </div>
            <div *ngIf="!showData" class="form-row">
                <div class="form-group">
                    <div class="form-label">Class/Standard/Year</div>
                    <div class="form-separator">:</div>
                    <div class="form-value">{{questionnarieData?.year ? questionnarieData?.year : '--'}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group">
                    <div class="form-label"> {{showData ? "Institution Name" : "Institutional Address"}}</div>
                    <div class="form-separator">:</div>
                    <div class="form-value">{{ questionnarieData?.address ? questionnarieData?.address : '--' }}</div>
                </div>
            </div>
        </div>
        <table class="table table-bordered w-100 mt-3">
            <thead>
                <tr>
                    <th class="question-label col-md-1 fw-bold question-sno">S.No.</th>
                    <th class="question-label col-md-5 fw-bold">Aspects</th>
                    <th class="question-label col-md-6 fw-bold">Responses</th>
                </tr>
            </thead>
            <tbody *ngIf="!error">
                <tr *ngFor="let field of questionAnswer; let i = index">
                    <td class="question-no text-center align-middle">{{ i + 1 }}</td>
                    <td class="question-label align-middle justify-center">{{ field.question || '-' }}</td>
                    <td class="question-answer text-justify">
                        <ng-container *ngIf="Array.isArray(field.answer); else notArray">
                            {{ field.answer.length ? field.answer.join(', ') : '-' }}
                        </ng-container>
                        <ng-template #notArray>
                            {{ field.answer || '-' }}
                        </ng-template>
                    </td>
                </tr>
            </tbody>
            <tbody *ngIf="error">
                <p class="notCreated">No records found</p>
            </tbody>
        </table>
        <div class="d-grid gap-2 d-md-flex justify-content-md-end hide-in-pdf " *ngIf="showButton">
            <button type="submit" class="btn btn-primary" (click)="sendHtmlToBackend()">Send Mail</button>
        </div>
    </div>
</div>
<div class="loader" *ngIf="spinner"></div>